import React from 'react';
import Icon, { IconProps } from './Icon';

const InfoIcon: React.FC<IconProps> = ({ size = 24, color = 'currentColor', ...props }) => {
  return (
    <Icon size={size} color={color} viewBox="0 0 24 24" {...props}>
      <path
        d="M12.0002 16V12M12.0002 8H12.0102M22.0002 12C22.0002 17.5228 17.5231 22 12.0002 22C6.4774 22 2.00024 17.5228 2.00024 12C2.00024 6.47715 6.4774 2 12.0002 2C17.5231 2 22.0002 6.47715 22.0002 12Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </Icon>
  );
};

export default InfoIcon;

